type ChangePasswordErrorProps = {
  password?: string;
  confirmPassword?: string;
};

export class ChangePasswordErrorModel {
  password?: string;
  confirmPassword?: string;

  constructor(data: ChangePasswordErrorProps = {}) {
    this.password = data.password || "";
    this.confirmPassword = data.confirmPassword || "";
  }
}
